<template>
  <div class="text-neutral-700">
    <slot name="special">
      <p
        v-if="special"
        class="relative mt-7 text-[30px] font-bold leading-6 text-neutral-900 [&_span]:text-[40px] [&_sup]:top-[-0.7em] [&_sup]:mr-[2px] [&_sup]:text-[20px]"
        :class="{ '!mt-0 w-max !text-sm !font-normal !leading-7 text-neutral-900 before:absolute before:inset-x-0 before:top-1/2 before:-rotate-12 before:border-t before:border-primary-700': regular }"
        v-html="regular ? regular : price.special"
      />
    </slot>
    <slot name="regular">
      <p
        v-if="regular && special"
        class="text-[30px] font-bold leading-6 text-primary-700 [&_span]:text-[40px] [&_sup]:top-[-0.7em] [&_sup]:mr-[2px] [&_sup]:text-[20px]"
        v-html="price.special"
      />
    </slot>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  regular?: string;
  special?: string;
}
const props = defineProps<Props>();

const price = computed(() => {
  return {
    regular: props.regular?.toString()
      ?.replace(/(\d[\d\s]*),(\d{2})/, `<span>${props.regular?.toString()?.match(/(\d[\d\s]*),(\d{2})/)?.[1]}</span><sup>${props.regular?.toString()?.match(/(\d[\d\s]*),(\d{2})/)?.[2]}</sup>`).replace(/\s/g, ''),
    special: props.special?.toString()
      ?.replace(/(\d[\d\s]*),(\d{2})/, `<span>${props.special?.toString()?.match(/(\d[\d\s]*),(\d{2})/)?.[1]}</span><sup>${props.special?.toString()?.match(/(\d[\d\s]*),(\d{2})/)?.[2]}</sup>`).replace(/\s/g, ''),
  };
});
</script>
